import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Offline shell: precache the built app so it cold-starts without a network round-trip in the
// field. Assessment data is already offline-first (Firestore persistentLocalCache). To back this
// out remotely, swap register() for serviceWorkerRegistration.unregister() and redeploy.
//
// Auto-adopt new deploys. The CRA default installs a new service worker but leaves it "waiting"
// until every tab of the app is closed — so a plain refresh keeps serving the previously cached
// bundle and shipped fixes appear not to take. Instead, when an update is found we tell the
// waiting worker to activate (it has a SKIP_WAITING handler + clientsClaim), then reload once it
// controls the page. The controllerchange listener is attached only on a real update, so a
// first-ever install (no prior controller) does not trigger a reload. Safe mid-session: edits
// autosave to Firestore's IndexedDB immediately, offline included.
serviceWorkerRegistration.register({
  onUpdate: registration => {
    if (!registration.waiting) return;
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
